import axios from "axios";
import {BASE_URL} from './constants';
export function uploadMedia(data, token) {
    const formData = new FormData();
    formData.append('file',data)
    const headers = {Authorization: `token ${token}`};
    return axios.post(`${BASE_URL}/medias/`,formData,{headers})
    .then(res => res.data)
    .catch(err => {
        console.log(err)
    })
}